import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { HeaderContext } from "../../../contexts/HeaderContext";
import { PromptContext } from "../../../contexts/SideMenuUserContext";
import { SignalRContext } from "../../../contexts/SignalRContext";
import { useMsal } from "@azure/msal-react";
import useLayout from "../../../hooks/useLayout";
import useDecode from "../../../hooks/useDecode";
import { safeRedirect } from "../../../utils/security";
import { clearAllCookies } from "../../../utils/cookieUtils";
import { ROLES } from "hooks/useGetRole";
import Moment from "moment";

import IconClose    from "../../../img/NewDesign/img/x.svg";
import IconUser     from "../../../img/NewDesign/img/user.svg";
import IconSettings from "../../../img/NewDesign/img/settings.svg";
import IconAyuda    from "../../../img/NewDesign/img/info.svg";
import IconAvisos   from "../../../img/NewDesign/img/alert.svg";
import IconEncuestas from "../../../img/NewDesign/img/file.svg";
import IconLogout   from "../../../img/NewDesign/img/logout.svg";

import "./SideMenuUserNew.scss";

interface Imembership {
  id: string;
  name: string;
  description: string;
  user_id: string;
  account_id: string;
  company_id: string;
  role: number;
}

const SideMenuUserNew: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const { handleAbortSignalR } = useContext(SignalRContext);
  const { headerState, setHeaderState } = useContext(HeaderContext);
  const { roleSelected } = useContext(PromptContext);
  const [rolePermisionsType, setRolePermisionsType] = useState(null);
  const [allMembership, setAllMembership] = useState<any[]>([]);
  const [userToken, setUserToken] = useState<any>({});
  const { instance } = useMsal();
  const { rolePermision } = useLayout();
  const [lastLogin, setLastLogin] = useState('');
  const [interactionInProgress, setInteractionInProgress] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  const tokenResponse = useDecode("token");

  useEffect(() => {
    if (tokenResponse !== undefined) {
      setUserToken(tokenResponse);
      saveLastLogin(tokenResponse);
    }

    const LSallMembership = localStorage.getItem("allMembership");
    if (typeof rolePermision === "string") {
      setRolePermisionsType(rolePermision);
    }
    if (typeof LSallMembership === "string") {
      setAllMembership(JSON.parse(LSallMembership));
    }
  }, [headerState]);

  const handleOnSwithMembership = (item: Imembership) => {
    setHeaderState({ ...headerState, identity: userToken.extension_id });
    redirection(item, item.role);
  };

  const redirection = (data: any, role: number) => {
    const path = checkPath(role);
    const membershipStr = JSON.stringify(data);
    if (path?.includes("http")) {
      safeRedirect(
        path + "/inicio-registro/" + userToken.extension_id + "/" + membershipStr
      );
    } else {
      navigate(path, { state: data, replace: true });
    }
  };

  const checkPath = (permission: number) => {
    switch (permission) {
      case 1:
      case 2:
      case 4:
      case 5:
      case 6:
        return import.meta.env.VITE_REACT_APP_COMPANIESSPA_HOSTNAME;
      case 3:
        return "/inicio";
      default:
        break;
    }
  };

  const closeSideMenu = () => {
    setHeaderState({ sideMenuVisible: false });
  };

  const DELTA_SEARCH_PATHS = [
    '/unidad-delta/accidentes-con-baja-pendientes-de-delta',
    '/unidad-delta/accidentes-con-baja-delta-remesados',
    '/unidad-delta/accidentes-sin-baja-pendientes-delta',
    '/unidad-delta/accidentes-sin-baja-delta-remesados',
  ];

  const handleAyuda = () => {
    closeSideMenu();
    if (currentPath === '/' || currentPath === '/inicio') {
      window.dispatchEvent(new CustomEvent('solimat:startHomeTour'));
    } else if (currentPath === '/unidad-delta') {
      window.dispatchEvent(new CustomEvent('solimat:startDeltaTour'));
    } else if (DELTA_SEARCH_PATHS.includes(currentPath)) {
      window.dispatchEvent(new CustomEvent('solimat:startDeltaSearchTour'));
    } else if (currentPath === '/mis-citas') {
      window.dispatchEvent(new CustomEvent('solimat:startAppointmentsTour'));
    } else if (currentPath === '/mis-gestiones') {
      window.dispatchEvent(new CustomEvent('solimat:startManagementTour'));
    } else if (currentPath === '/historial') {
      window.dispatchEvent(new CustomEvent('solimat:startRecordTour'));
    } else if (currentPath.match(/^\/historial\/\d+(_\w+)?/)) {
      window.dispatchEvent(new CustomEvent('solimat:startRecordDetailTour'));
    } else if (currentPath === '/notificaciones') {
      window.dispatchEvent(new CustomEvent('solimat:startNotificationsTour'));
    } else if (currentPath === '/comunicaciones') {
      window.dispatchEvent(new CustomEvent('solimat:startCommunicationsTour'));
    } else if (currentPath.match(/^\/comunicaciones\/.+\/comunicacion-general/)) {
      window.dispatchEvent(new CustomEvent('solimat:startCommunicationChatTour'));
    } else if (currentPath === '/red-de-centros') {
      window.dispatchEvent(new CustomEvent('solimat:startCentersTour'));
    } else {
      navigate('/ayuda');
    }
  };

  const handleLogout = async () => {
    try {
      if (loggingOut || interactionInProgress) return;
      setLoggingOut(true);
      setInteractionInProgress(true);
      clearAllCookies();
      localStorage.clear();
      sessionStorage.clear();
      await instance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin + "/inicio",
      });
    } catch (error) {
      console.error("Logout error:", error);
      clearAllCookies();
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/inicio";
    } finally {
      setLoggingOut(false);
      setInteractionInProgress(false);
    }
  };

  const saveLastLogin = (token: any) => {
    if (token?.extension_last_signin) {
      const date = Moment.unix(Number(token.extension_last_signin));
      if (date.isValid()) {
        setLastLogin(date.format("DD/MM/YY HH:mm:ss"));
      }
    }
  };

  return (
    <>
      {(allMembership.length >= 1 || true) && (
        <div
          className={`side-menu-new-wrapper ${headerState.sideMenuVisible ? "" : "collapsed"}`}
        >
          <div className="bg" onClick={closeSideMenu} />
          <div className="side-menu-new_block">

            {/* Header: close + user info */}
            <div className="side-menu-new_header">
              <button className="btn-close-new" onClick={closeSideMenu}>
                <img src={IconClose} alt="Cerrar" />
              </button>

              <div className="user-info-new">
                <div className="icon-container-new">
                  <img src={IconUser} alt="" />
                </div>
                <div className="user-info-new-text">
                  <h2 className="user-name-new">
                    {userToken.extension_first_name ?? "-"}{" "}
                    {userToken.extension_first_last_name ?? "-"}
                  </h2>
                </div>
              </div>
            </div>

            {/* Nav links */}
            <div className="nav-list-new-container">
              <nav>
                <Link to="/ajustes" onClick={closeSideMenu}>
                  <span className="nav-new-icon"><img src={IconSettings} alt="" /></span>
                  Ajustes de usuario
                </Link>
                <a className="nav-action" onClick={handleAyuda} style={{ cursor: 'pointer' }}>
                  <span className="nav-new-icon"><img src={IconAyuda} alt="" /></span>
                  Ayuda
                </a>
                <Link to="/avisos" onClick={closeSideMenu}>
                  <span className="nav-new-icon"><img src={IconAvisos} alt="" /></span>
                  Avisos
                </Link>
                <Link to="/mis-encuestas" onClick={closeSideMenu}>
                  <span className="nav-new-icon"><img src={IconEncuestas} alt="" /></span>
                  Encuestas
                </Link>
                <a className="nav-action" onClick={handleLogout}>
                  <span className="nav-new-icon"><img src={IconLogout} alt="" /></span>
                  Cerrar sesión
                </a>
              </nav>
            </div>

            {/* Footer: last login */}
            {lastLogin && (
              <div className="side-menu-new_footer">
                <p className="last-login-new">
                  Última conexión: <strong>{lastLogin}</strong>
                </p>
              </div>
            )}

          </div>
        </div>
      )}
    </>
  );
};

export default SideMenuUserNew;
